<template>
  <div class="content-container flex-column">
    <!-- Kontrakt Toolbar -->
    <div class="grid-x toolbar fixed responsive-small-only">
      <div class="cell auto toolbar-responsive">
        <ul class="toolbar-title-breadcrumbs">
          <li>
            <a href="javascript:;" @click="hideAr()">Kontrakter</a>
            <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-arrow-right"></use></svg>
          </li>
          <li>
            <a href="javascript:;">{{ kontrakt.Kontraktnr }}</a>
            <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-arrow-right"></use></svg>
          </li>
        </ul>
      </div>
    </div>

    <!-- Content -->
    <div class="content-container flex-row no-flex-grow">
      <overlay-scrollbars :options="{ className: 'content-container flex-column os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
        <section class="content xlarge-padding border-bottom">
          <TheLoader :active="$store.getters.isFormLoading" :small="true"/>

          <div class="grid-x">
            <div class="cell auto">
              <span class="icon-heading-title">
                <span class="title">AR-FAKTURA</span>
              </span>
            </div>
             <div class="cell shrink align-right">
               <span class="button-container has-popover" :class="{'popover-active': formPopoverActive}" @click="toggleFormPopover()">
                 <span class="button action glyph"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-edit"></use></svg> <span>Innstillinger</span></span>
                 <span class="popover popover-has-footer align-x-right align-y-bottom xlarge">
                   <ul>
                     <li>
                       <TheSwitchInputPopover v-model="internal.Utlevert" label="Sett objektene som utlevert" labelTrue="" labelFalse="" :trueValue="true" :falseValue="false"/>
                     </li>
                     <li :class="{'disabled': !internal.Utlevert}">
                       <TheSwitchInputPopover v-model="internal.Lagerleie" label="Beregn ev lagerleie" labelTrue="" labelFalse="" :trueValue="true" :falseValue="false" :disabled="!internal.Utlevert"/>
                     </li>
                   </ul>
                 </span>
               </span>
             </div>
           </div>
          <table class="medium padding margin-top margin-bottom">
            <template v-for="obj in objektWithBilag">
              <thead :key="'head-' + obj.Objektnr">
                <tr>
                  <td colspan="2"><strong>{{obj.Objektnr}}</strong></td>
                  <td colspan="3" class="align-right">
                    <span class="button-container has-popover" :class="{'popover-active': isVarePopoverActive(obj.Objektnr)}" @click="toggleVarePopover(obj.Objektnr)">
                      <span class="button action glyph"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-add"></use></svg> <span>Ny fakturalinje</span></span>
                      <span class="popover align-x-right align-y-bottom xlarge">
                        <overlay-scrollbars :options="{ className: 'custom-scrollbar os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
                        <ul>
                          <li v-for="item in getVarePopoverOptions(obj).sort(sortLinevalues)" v-bind:key="'add-' + item.data.Vareid">
                            <a href="javascript:;" @click="addVare(obj, item)" class="add-form-line popover-form-line"><span>{{item.data.Beskrivelse || item.val}} <span class="label">{{item.val}}</span></span></a>
                          </li>
                        </ul>
                        </overlay-scrollbars>
                      </span>
                    </span>
                  </td>
                </tr>
                <tr>
                  <th>Beskrivelse</th>
                  <th>Kode</th>
                  <th class="align-right">Pris eks. mva</th>
                  <th class="align-right">Pris inkl. mva</th>
                  <th class="align-right">&nbsp;</th>
                </tr>
              </thead>
              <tbody :key="'body-' + obj.Objektnr">
                <tr v-for="line in obj.bilag_draft.bilagslinje" :key="obj.Objektnr + '-' + line.Internalid">
                  <td>
                    <div class="input-container minimal no-margin large text">
                      <input type="text" v-model="line.Beskrivelse" maxlength="100">
                      <span class="glyph"><svg viewBox="0 0 44 44"><use xlink:href="/static/sprites.svg#button-glyph-pencil"></use></svg></span>
                    </div>
                  </td>
                  <td>
                    <span class="label">{{line.Varenr}}</span>
                  </td>
                  <td class="align-right opacity-60">
                    {{line.Belop | thousandsFloat}}
                  </td>
                  <td class="align-right">
                    <span v-if="!line.Internaledit">{{line.Beloptotal | thousandsFloat}}</span>
                    <TheDecimalInputTable v-else v-model="line.Beloptotal" containerClassName="input-container minimal align-right no-margin small" @blur="onValueChange($event, obj, line)"/>
                  </td>

                  <td class="align-right">
                    <a href="javascript:;" v-if="line.Internaldel" @click="delVare(obj, line)" class="button action input-action glyph glyph-only no-margin"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-delete"></use></svg></a>
                    <a href="javascript:;" v-else class="button action input-action glyph glyph-only no-margin disabled" disabled><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-delete"></use></svg></a>
                  </td>
                </tr>
                <tr><td colspan="5"><br></td></tr>
              </tbody>
            </template>
            <tfoot class="highlight">
              <tr>
                <td colspan="2"><strong>Total</strong></td>
                <td class="align-right"><strong>{{totalPriceExc}}</strong></td>
                <td class="align-right"><strong>{{totalPriceInc}}</strong></td>
                <td>&nbsp;</td>
              </tr>
            </tfoot>
          </table>

          <div class="grid-x">
            <div class="cell auto"></div>

            <!-- Normal invoice -->
            <div class="cell shrink">
              <a v-if="!$store.getters.isFormLoading && !$store.getters.isFormProcessing" href="javascript:;" class="button primary submit large" @click="openSaveModal()">Opprett faktura</a>
              <a v-else href="javascript:;" class="button primary submit large" disabled>Opprett faktura</a>
            </div>
          </div>
        </section>
      </overlay-scrollbars>
    </div>
  </div>
</template>

<script>
import ObjektService from '@/services/ObjektService'
import InstillingerService from '@/services/InstillingerService'
import bus from '@/plugins/event-bus'
import moment from 'moment'
import accounting from 'accounting-js'

/** Lagerleie varekode per department (Avdelingsid). null = default/fallback */
const LAGERLEIE_VAREKODE_CONFIG = [
  { avdelingsid: 2, varekode: 'LLUKE2' }, // Vin
  { avdelingsid: null, varekode: 'LLUKE' } // Default
]

const getLagerleieVarekode = (avdelingsid) => {
  const config = LAGERLEIE_VAREKODE_CONFIG.find(c => c.avdelingsid === avdelingsid) ||
                 LAGERLEIE_VAREKODE_CONFIG.find(c => c.avdelingsid === null)
  return config ? config.varekode : 'LLUKE'
}

export default {
  name: 'KundeKontraktInvoiceAr',
  props: {
    kunde: {
      type: Object,
      required: true
    },
    kontrakt: {
      type: Object,
      required: true
    },
    objektList: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      loaded: 0,
      internal: {
        Utlevert: false,
        Lagerleie: false
      },
      form: {
        Bilagstype: 'F',
        Retur: 'T',
        Export: 'F',
        Mvafri: 'F',
        objektdata: {
          Mottaker: null,
          // Salgspris: this.objekt.Salgspris, ??
          Auksjon: null
        }
      },
      vareList: [],
      vareOptionsUsed: {},
      varePopoverActive: {},
      formPopoverActive: false,
      objektWithBilag: []
    }
  },
  created () {
    bus.$off('bilag-kunde-updated')
    bus.$off('invoice-created')

    var vm = this

    window.jQuery(document).mouseup(function (e) {
      var container = window.jQuery('.has-popover')
      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        vm.varePopoverActive = {}
        vm.formPopoverActive = false
      }
    })

    this.$set(this.form.objektdata, 'Mottaker', this._.cloneDeep(this.kunde))
    // this.form.objektdata.Mottaker = this._.clone(this.kunde)

    this.setFormLoading(true)
    this.fetch()
    this.fetchDrafts()
  },
  mounted () {
    bus.$on('bilag-kunde-updated', (data) => this.onKundeAddressUpdated(data))
    bus.$on('invoice-created', (data) => this.onInvoiceCreated(data))
  },
  watch: {
    loaded: function (newVal) {
      if (newVal >= 2) {
        this.setFormLoading(false)
      }
    },
    'internal.Utlevert': function (newVal) {
      if (newVal === false) {
        this.internal.Lagerleie = false
      }
    },
    'internal.Lagerleie': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        console.log('Lagerleie add/del', newVal)
        this.toggleLagerLeieLines()
      }
    },
    vareList: function (newVal) {
      // if vareList is loaded and objektList is loaded, recriate the lines
      if (newVal.length > 0 && this.objektList.length > 0) {
        console.log('VareList loaded, recriating lines...')
        this.fetchDrafts()
      }
    }
  },
  computed: {
    totalPriceInc: function () {
      let retval = 0

      this.objektWithBilag.forEach((obj) => {
        obj.bilag_draft.bilagslinje.forEach((line) => {
          if (line.Beloptotal !== null && line.Beloptotal !== '') {
            retval += parseFloat(line.Beloptotal)
          }
        })
      })

      return accounting.formatNumber(retval, { precision: 2, thousand: ' ' })
    },
    totalPriceExc: function () {
      let retval = 0

      this.objektWithBilag.forEach((obj) => {
        obj.bilag_draft.bilagslinje.forEach((line) => {
          if (line.Belop !== null && line.Belop !== '') {
            retval += parseFloat(line.Belop)
          }
        })
      })

      return accounting.formatNumber(retval, { precision: 2, thousand: ' ' })
    }
  },

  /**
   * TODO
   *
   * - Alla verdier skall vara +
   * -
   */
  methods: {
    onInvoiceCreated: function (data) {
      this.$helpers.showSuccessAlert('Faktura er lagret')

      this.hideAr()
    },
    onValueChange: function (event, obj, line) {
      const vidx = this.vareList.findIndex(x => x.data.Varekode === line.Varenr)

      // if the item was not found
      if (vidx === -1) {
        console.warn('Item not found for Varenr:', line.Varenr)
        return
      }

      const item = this.vareList[vidx]

      // if item or item.data is undefined
      if (!item || !item.data) {
        console.warn('Item or item.data is undefined for Varenr:', line.Varenr)
        return
      }

      const mvap = this.form.Mvafri === 'F' && item.data.mva && item.data.mva.Mvapct ? item.data.mva.Mvapct : 0

      let Pris = parseFloat(line.Beloptotal || 0)

      if (this.form.Mvafri === 'F') {
        if (!this.hasBKH() || item.data.Mvakode !== 'BKH') {
          if (Pris > 0 && mvap) {
            Pris = Pris / ((100 + parseInt(mvap)) / 100)
          }
        }
      }

      let Mvabelop = 0
      let Belop = line.Antall * Pris

      if (line.Varenr === 'SALÆR') {
        Mvabelop = Belop * (mvap / 100)
      } else if (this.form.Mvafri === 'F' && mvap) {
        Mvabelop = Belop * (mvap / 100)
      }

      const Beloptotal = Belop + Mvabelop

      line.Pris = accounting.formatNumber(Pris, { precision: 2, thousand: '' })
      line.Belop = accounting.formatNumber(Belop, { precision: 2, thousand: '' })
      line.Mvagrunnlag = accounting.formatNumber(Belop, { precision: 2, thousand: '' })
      line.Mvabelop = accounting.formatNumber(Mvabelop, { precision: 2, thousand: '' })
      line.Beloptotal = accounting.formatNumber(Beloptotal, { precision: 2, thousand: '' })

      // let Pris = parseFloat(line.Belop || 0)

      // // Must increase by possible MVA, as it will be reduced in the makeVareLine method.
      // if (Pris > 0 && item.data.Prisinclmva === 'T' && item.data.mva && item.data.mva.Mvapct) {
      //   Pris = Pris * ((100 + parseInt(item.data.mva.Mvapct)) / 100)
      // }

      // if (Pris > 0 && item.data.Prisinclmva === 'T' && item.data.mva.Mvapct) {
      //   Pris = Pris / ((100 + parseInt(item.data.mva.Mvapct)) / 100)
      // }

      // let Belop = line.Antall * Pris

      // // Special for Lagerleie - We don't use antal here, when manually setting the price
      // if (line.Varenr === 'LLUKE') {
      //   Belop = Pris
      // }

      // const Mvabelop = Belop * (item.data.mva.Mvapct ? (item.data.mva.Mvapct / 100) : 0)

      // line.Pris = accounting.formatNumber(Pris, { precision: 2, thousand: '' })
      // line.Belop = accounting.formatNumber(Belop, { precision: 2, thousand: '' })
      // line.Mvagrunnlag = accounting.formatNumber(Belop, { precision: 2, thousand: '' })
      // line.Mvabelop = accounting.formatNumber(Mvabelop, { precision: 2, thousand: '' })
      // line.Beloptotal = accounting.formatNumber(Belop + Mvabelop, { precision: 2, thousand: '' })
    },
    toggleLagerLeieLines: function () {
      this.objektWithBilag.forEach((obj) => {
        let index = obj.bilag_draft.bilagslinje.findIndex(line => line.Varenr === getLagerleieVarekode(obj.Avdelingsid))

        if (index === -1) {
          // Objekt have NO lagerleie
          if (this.internal.Lagerleie) {
            this.addLagerLeie(obj)
          }
        } else {
          // Objekt have lagerleie
          if (!this.internal.Lagerleie) {
            obj.bilag_draft.bilagslinje.splice(index, 1)
          }
        }
      })
    },
    fetch: function () {
      InstillingerService('vare').dropdownByParams({ type: 'K' })
        .then((response) => {
          // Get result and add a used property
          this.vareList = response.data.map(obj => ({ ...obj, Used: false }))
        })
        .catch((e) => {
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste inn instillinger')
        })
        .then(() => {
          ++this.loaded
        })
    },

    fetchDrafts: function () {
      // if vareList is not loaded, wait for it
      if (this.vareList.length === 0) {
        console.log('Waiting for vareList to be loaded...')
        return
      }

      ObjektService.getSellerObjektWithDraftBilag({ list: this.objektList })
        .then((response) => {
          this.setupObjektBilagLines(response.data)
        })
        .catch((error) => {
          console.log('Error', error)
        })
        .then(() => {
          ++this.loaded
        })
    },

    setupObjektBilagLines: function (items) {
      items.forEach(o => {
        let objektData = []
        objektData = this._.clone(o)

        if (!objektData.bilag_draft) {
          /**
           * Have no bilag and no lines, so make default (objekt + auksjonshonorar)
           */
          objektData.bilag_draft = {
            Internalid: 'new-bilag-' + objektData.Objektnr,
            bilagslinje: []
          }

          this.addObjekt(objektData)
          this.addAuksjonsHonorar(objektData)

          // Skip lagerleie as default to begin with at least...
          // It will be added/removed by the internal.Lagerleie boolean
          // this.addLagerLeie(objektData)

          // if the lines were not created correctly
          if (objektData.bilag_draft.bilagslinje.length === 0) {
            console.warn('No lines were created for objekt:', objektData.Objektnr)
          }

          this.objektWithBilag.push(objektData)
        } else if (!objektData.bilag_draft.bilagslinje) {
          /**
           * Have bilag but no lines, so make default (objekt + auksjonshonorar)
           */
          objektData.bilag_draft.Internalid = objektData.bilag_draft.Bilagsid
          objektData.bilag_draft.bilagslinje = []

          this.addObjekt(objektData)
          this.addAuksjonsHonorar(objektData)

          // if the lines were not created correctly
          if (objektData.bilag_draft.bilagslinje.length === 0) {
            console.warn('No lines were created for objekt (bilag without lines):', objektData.Objektnr)
          }

          this.objektWithBilag.push(objektData)
        } else {
          /**
           * Have bilag + lines -> parse and format lines
           */
          // Make a copy of current bilaglines for looping
          const linesCopy = this._.clone(objektData.bilag_draft.bilagslinje)

          // Reset current bilaglines
          objektData.bilag_draft.Internalid = objektData.bilag_draft.Bilagsid
          objektData.bilag_draft.bilagslinje = []

          // Loop and remove the ones not needed
          linesCopy.forEach(line => {
            if (line.Varenr === 'SALÆR' || line.Varenr === 'OPPGJØR') {
              return
            }

            if (line.Varenr === objektData.Objektnr) {
              // console.log('Sme: ', line.Varenr)
              line.Belop = accounting.formatNumber(0, { precision: 2, thousand: '' })
              line.Beloptotal = accounting.formatNumber(0, { precision: 2, thousand: '' })
              line.Pris = accounting.formatNumber(0, { precision: 2, thousand: '' })
              line.Mvagrunnlag = accounting.formatNumber(0, { precision: 2, thousand: '' })
              line.Mvabelop = accounting.formatNumber(0, { precision: 2, thousand: '' })
              line.Internalid = line.Bilagslinjeid
              line.Internaledit = false
              line.Internaldel = false
            } else {
              // Must set these as positive values
              line.Pris = Math.abs(line.Pris)
              line.Belop = Math.abs(line.Belop)
              line.Mvabelop = Math.abs(line.Mvabelop)

              line.Internalid = line.Bilagslinjeid
              line.Internaledit = true
              line.Internaldel = true
              line.Beskrivelse = line.Beskrivelse || line.Varenr
              line.Beloptotal = accounting.formatNumber((line.Belop || 0) + (line.Mvabelop || 0), { precision: 2, thousand: '' })
              line.Pris = accounting.formatNumber(line.Pris || 0, { precision: 2, thousand: '' })
              line.Belop = accounting.formatNumber(line.Belop || 0, { precision: 2, thousand: '' })
              line.Mvagrunnlag = accounting.formatNumber(line.Belop || 0, { precision: 2, thousand: '' })
              line.Mvabelop = accounting.formatNumber(line.Mvabelop || 0, { precision: 2, thousand: '' })
            }

            objektData.bilag_draft.bilagslinje.push(line)
          })

          this.objektWithBilag.push(objektData)
        }
      })

      // force reactivity after processing all objects
      this.$nextTick(() => {
        this.$forceUpdate()
      })
    },

    addObjekt: function (objekt) {
      let title = 'Retur: ' + objekt.title + (objekt.subtitle ? ' / ' + objekt.subtitle : '')

      const index = this.vareList.findIndex(x => x.data.Varekode === 'OBJEKT')

      if (index === -1) {
        return
      }

      const item = this.vareList[index]

      const data = {
        Antall: 1,
        Pris: null,
        Mvapct: null,
        Varetype: 'O',
        Varenr: objekt.Objektnr,
        Beskrivelse: title,
        Internaldel: false,
        Internaledit: false
      }

      const line = this.makeVareLine(objekt, item, data)

      if (line) {
        objekt.bilag_draft.bilagslinje.push(line)
        this.$set(this.vareOptionsUsed, objekt.Objektnr + ':' + item.data.Varekode, true)
      } else {
        console.warn('Failed to create line for objekt:', objekt.Objektnr)
      }
    },

    addAuksjonsHonorar: function (objekt) {
      const index = this.vareList.findIndex(x => x.data.Varekode === 'FOTO')

      if (index === -1) {
        return
      }
      const item = this.vareList[index]
      const data = {
        Antall: 1,
        Pris: parseFloat(objekt.Fotokostnad),
        Mvapct: item.data.mva && item.data.mva.Mvapct ? item.data.mva.Mvapct : 0,
        Varetype: 'V',
        Varenr: item.data.Varekode,
        Beskrivelse: item.data.Beskrivelse || item.data.Varekode,
        Internaldel: true,
        Internaledit: true
      }

      const line = this.makeVareLine(objekt, item, data)

      if (line) {
        objekt.bilag_draft.bilagslinje.push(line)
        this.$set(this.vareOptionsUsed, objekt.Objektnr + ':' + item.data.Varekode, true)
      } else {
        console.warn('Failed to create line for auksjonshonorar:', objekt.Objektnr)
      }
    },

    addLagerLeie: function (objekt) {
      const index = this.vareList.findIndex(x => x.data.Varekode === getLagerleieVarekode(objekt.Avdelingsid))

      if (index === -1) {
        return
      }

      const lagerleieWeeks = this.getLagerleieWeeks(objekt)

      if (!lagerleieWeeks) {
        return
      }

      const item = this.vareList[index]
      const data = {
        Antall: lagerleieWeeks.weeks,
        Pris: item.data.Pris ? parseFloat(item.data.Pris) : 0,
        Mvapct: item.data.mva && item.data.mva.Mvapct ? item.data.mva.Mvapct : 0,
        Varetype: 'V',
        Varenr: item.data.Varekode,
        Beskrivelse: item.data.Beskrivelse + ' (' + lagerleieWeeks.from + ' - ' + lagerleieWeeks.till + ')',
        Internaldel: true,
        Internaledit: true
      }

      const line = this.makeVareLine(objekt, item, data)

      if (line) {
        objekt.bilag_draft.bilagslinje.push(line)
        this.$set(this.vareOptionsUsed, objekt.Objektnr + ':' + item.data.Varekode, true)
      } else {
        console.warn('Failed to create line for lagerleie:', objekt.Objektnr)
      }
    },

    addVare: function (objekt, item) {
      // if item or item.data is undefined
      if (!item || !item.data) {
        console.warn('Item or item.data is undefined')
        this.$helpers.showErrorAlert('Feil', 'Ugyldig vare data')
        return
      }

      // Find index of vare in list
      const index = this.vareList.findIndex(x => x.data.Vareid === item.data.Vareid)

      if (index === -1) {
        this.$helpers.showErrorAlert('Feil', 'Kunne ikke finne vare')
        return
      }

      if (item.data.Varekode === 'FOTO') {
        this.addAuksjonsHonorar(objekt)
        return
      }

      if (item.data.Varekode === getLagerleieVarekode(objekt.Avdelingsid)) {
        this.addLagerLeie(objekt)
        return
      }

      const data = {
        Antall: 1,
        Pris: item.data.Pris ? parseFloat(item.data.Pris) : 0,
        Mvapct: this.form.Mvafri === 'F' && item.data.mva && item.data.mva.Mvapct ? item.data.mva.Mvapct : 0,
        Varetype: 'V',
        Varenr: item.data.Varekode,
        Beskrivelse: item.data.Beskrivelse || item.data.Varekode,
        Internaldel: true,
        Internaledit: true
      }

      const line = this.makeVareLine(objekt, item, data)

      if (line) {
        objekt.bilag_draft.bilagslinje.push(line)
        this.$set(this.vareOptionsUsed, objekt.Objektnr + ':' + item.data.Varekode, true)
      } else {
        console.warn('Falha ao criar linha para vare:', item.data.Varekode)
      }
    },
    hasBKH: function () {
      return false
    },
    delVare: function (objekt, line) {
      const index = objekt.bilag_draft.bilagslinje.findIndex(i => i.Internalid === line.Internalid)

      if (index === -1) {
        return
      }

      objekt.bilag_draft.bilagslinje.splice(index, 1)

      this.$delete(this.vareOptionsUsed, objekt.Objektnr + ':' + line.Varenr)
    },

    makeVareLine: function (objekt, vare, data, onlyRecalc) {
      // if vare or vare.data is undefined
      if (!vare || !vare.data) {
        console.warn('Vare or vare.data is undefined')
        return null
      }

      // check if data is undefined
      if (!data) {
        console.warn('Data is undefined')
        return null
      }

      // Caclulate some values, that are common for all types
      let Pris = data.Pris || 0

      // if (Pris > 0 && vare.data.Prisinclmva === 'T' && data.Mvapct) {
      //   Pris = Pris / ((100 + parseInt(data.Mvapct)) / 100)
      // }

      // const Belop = data.Antall * Pris
      // const Mvabelop = Belop * (data.Mvapct ? (data.Mvapct / 100) : 0)

      if (!onlyRecalc) {
        if (this.form.Mvafri === 'F') {
          if (!this.hasBKH() || vare.data.Mvakode !== 'BKH') {
            if (Pris > 0 && vare.data.Prisinclmva === 'T' && data.Mvapct) {
              Pris = Pris / ((100 + parseInt(data.Mvapct)) / 100)
            }
          }
        }
      } else {
        if (this.form.Mvafri === 'F') {
          if (!this.hasBKH() || vare.data.Mvakode !== 'BKH') {
            if (Pris > 0 && data.Mvapct) {
              Pris = Pris / ((100 + parseInt(data.Mvapct)) / 100)
            }
          }
        }
      }

      let Mvabelop = 0
      let Belop = data.Antall * Pris

      if (onlyRecalc && data.Varenr === 'SALÆR') {
        Mvabelop = Belop * (data.Mvapct / 100)
      } else if (this.form.Mvafri === 'F' && data.Mvapct) {
        Mvabelop = Belop * (data.Mvapct / 100)
      }

      const Beloptotal = Belop + Mvabelop

      let line = {
        Antall: data.Antall,
        Pris: accounting.formatNumber(Pris, { precision: 2, thousand: '' }),
        Belop: accounting.formatNumber(Belop, { precision: 2, thousand: '' }),
        Mvagrunnlag: accounting.formatNumber(Belop, { precision: 2, thousand: '' }),
        Mvabelop: accounting.formatNumber(Mvabelop, { precision: 2, thousand: '' }),
        Beloptotal: accounting.formatNumber(Beloptotal, { precision: 2, thousand: '' }),
        Mvakode: vare.data.Mvakode,
        Mvapct: data.Mvapct || null,
        Mvatype: vare.data.mva ? vare.data.mva.Mvatype : null,
        Beskrivelse: data.Beskrivelse,
        Bokforgruppekode: vare.data.bokforgruppe ? vare.data.bokforgruppe.Bokforgruppekode : '',
        Enhetskode: vare.data.Enhetskode,
        Vareid: vare.data.Vareid,
        Varenr: data.Varenr,
        Varetype: data.Varetype
      }

      if (!onlyRecalc) {
        line.Avgiftpct = null
        line.Bilagsid = null
        line.Bilagslinjeid = null
        line.Katalognr = null
        line.Linjenr = null
        line.Rabatbelop = null
        line.Rabatpct = null
        line.eurokurs = null
        line.Internalid = 'new-' + (objekt.Objektnr + '-' + objekt.bilag_draft.bilagslinje.length)
        line.Internaldel = data.Internaldel
        line.Internaledit = data.Internaledit
        line.Internalincmva = vare.data.Prisinclmva === 'T'
        line.Gruppe = objekt.Kontraktnr + '-' + String(objekt.Lopenr).padStart(3, '0')
        line.Objekt = objekt.Objektid
        line.Utlevdato = objekt.Lev_dato
      }

      return line
    },
    sortLinevalues: function (a, b) {
      let aText = a.data.Beskrivelse || a.val
      let bText = b.data.Beskrivelse || b.val
      return aText.localeCompare(bText)
    },
    getVarePopoverOptions: function (objekt) {
      // Get vare options list for an objekt
      return this.vareList.filter((i) => {
        if (i.data.Varekode === 'OBJEKT' || i.data.Varekode === 'SALÆR' || i.data.Varekode === 'OPPGJØR' || i.data.Varekode === 'FOTO' || i.data.Varekode === 'BKH') {
          return false
        }

        if (i.data.Varekode === getLagerleieVarekode(objekt.Avdelingsid) && this.getLagerleieWeeks(objekt) === null) {
          return false
        }

        if (this.vareOptionsUsed.hasOwnProperty(objekt.Objektnr + ':' + i.data.Varekode)) {
          return false
        }

        return true
      })
    },
    isVarePopoverActive: function (objektnr) {
      // Check if vare popover is active for an objekt
      return this.varePopoverActive.hasOwnProperty(objektnr)
    },
    toggleVarePopover: function (objektnr) {
      // Toggle vare option popover for an objekt
      if (this.varePopoverActive.hasOwnProperty(objektnr)) {
        this.$delete(this.varePopoverActive, objektnr)
      } else {
        this.$set(this.varePopoverActive, objektnr, true)
      }

      this.formPopoverActive = false
    },

    toggleFormPopover: function () {
      this.formPopoverActive = !this.formPopoverActive
      this.varePopoverActive = {}
    },

    getLagerleieWeeks: function (objekt) {
      // Check objekt
      if (!objekt.Lagerleieinfo || !objekt.Lagerleiedato) {
        return null
      }

      // Also check innlevav
      if (!objekt.innlevav || !objekt.innlevav.SendLagerleieinfo) {
        return null
      }

      const today = moment().format('YYYY-MM-DD')
      const ldato = moment(moment(objekt.Lagerleiedato).format('YYYY-MM-DD'))
      const diff = ldato.diff(today)

      // Only if today or less than today's date
      if (diff <= 0) {
        const totd = Math.abs(moment.duration(diff).as('days'))
        const totw = Math.floor(totd / 7) + ((totd % 7) > 0 ? 1 : 1)
        // weeks from object
        const weeks = objekt.lagerleie_weeks ? objekt.lagerleie_weeks : totw

        return {
          weeks: weeks,
          from: ldato.format('YYYY-MM-DD'),
          till: today
        }
      }

      return null
    },

    openSaveModal: function () {
      let data = this._.clone(this.form)
      // const today = moment().format('YYYY-MM-DD')

      // data.objektdata.Auksjon = null
      // data.objektdata.Fakturert = 'F'
      // data.objektdata.Fakturadato = today

      if (this.internal.Utlevert) {
        data.type = 'ar-utlevert'
        // data.objektdata.Bet_dato = today
        // data.objektdata.Lev_dato = today
        // data.objektdata.Lokasjon = 'Utlevert'
        // data.objektdata.Lokasjonid = 159
      } else {
        data.type = 'ar'
        // delete data.objektdata.Bet_dato
        // delete data.objektdata.Lev_dato
        // delete data.objektdata.Lokasjon
        // delete data.objektdata.Lokasjonid
      }

      console.log(data)
      console.log(this.objektWithBilag)

      // Må finnas en rad - åtminstone objektet skall finnas med.
      // Kolla i save vad som händer ifall det ikke finns kostnader.

      this.openModal('kunde-kontrakt-invoice-ar-modal',
        {
          data: data,
          kontrakt: this.kontrakt,
          objektlist: this.objektWithBilag,
          internalWindow: true
        },
        'split'
      )
    },
    onKundeAddressUpdated: function (data) {
      console.log('Back in AR - After kunde address updated')

      // Todo: Fix the errior here

      this.$set(this.form.objektdata, 'Mottaker', this._.cloneDeep(data))

      bus.$emit('kunde-merged', data)
    },
    hideAr: function () {
      bus.$emit('hide-kontrakt-invoice-ar')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/KundeKontraktInvoiceAr.vue